import { render, staticRenderFns } from "./ProductGridItem.vue?vue&type=template&id=1c55f094&"
import script from "./ProductGridItem.vue?vue&type=script&lang=js&"
export * from "./ProductGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports